import { PropertyErrorModel } from 'libs/shared/src/lib/models/property-error.model';

export class UploadMaterialMetadataModel {
  public guid: string = '';
  public name: string = '';
  public size: number;
  public pages: number;
  public contentType: string = '';
  public documentKey: string = '';
  public awsVersionId: string = '';
  public createdOn: Date;
  public errors: PropertyErrorModel[] = [];
  public hasOutline: boolean;
  public isPasswordProtected: boolean;
  public hasFormFields: boolean;

  constructor(init?: Partial<UploadMaterialMetadataModel>) {
    Object.assign(this, init);
  }
}
